import { isHtm } from "./const";
export const normalLanguageArr = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: '日本語',
    value: 'ja'
  },
  {
    label: '한국어',
    value: 'ko',
  },
  {
    label: 'ไทย',
    value: 'th',
  },
];

export const htmLanguageArr = [
  {
    label: '繁中',
    value: 'zh',
  },
]

export const languageArr = isHtm ? htmLanguageArr: normalLanguageArr;
export function setLanguageDialog(event: Event) {
  event.stopPropagation();
  const langbox= window.$('.top_language');
  if (langbox.hasClass('active')) {
    langbox.removeClass('active');
  } else {
    langbox.addClass('active');
  }
}

export function closeLangDialog() {
  window.$('.lang-box').removeClass('active');
}